<template>
  <div class="panel-st v-expansion-panel__container" :class="{ 'v-expansion-panel__container--active': isActive }">
    <a class="v-expansion-panel__header panel-st__header" :href="'#panel-service-type-' + _uid" :title="'Add ' + serviceType.name" @click.prevent="activatePanel">
      <h4 class="panel-st__label">
        <span v-if="isActive">Add</span>
        <v-icon small v-else>add_circle</v-icon>
        {{ serviceType.name }}
      </h4>
      <div class="v-expansion-panel__header__icon">
        <v-icon>keyboard_arrow_down</v-icon>
      </div>
    </a>
    <transition @enter="enter" @leave="leave" :css="false">
      <div :id="'panel-service-type-' + _uid" class="v-expansion-panel__body panel-st__body" v-if="isActive">
        <v-card class="grey darken-4 panel-st__card">
          <service-type-recommendations
            :popular-providers="PopularProviders"
            :service-type="serviceType"
            :is-active="isActive"
            v-if="isLoaded"
          />
          <placeholder v-else />
        </v-card>
      </div>
    </transition>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import axios from 'axios'
  import Placeholder from './ServiceTypePlaceholder'
  import ServiceTypeRecommendations from './ServiceTypeRecommendations'
  import sidebarMixin from '@/mixins/sidebar'

  export default {
    mixins: [sidebarMixin],
    data () {
      return {
        PopularProviders: null,
        currentView: Placeholder
      }
    },
    computed: {
      ...mapState('recommendations', ['activeServiceType']),
      isActive () {
        return this.activeServiceType === this.serviceType
      },
      isLoaded () {
        return Array.isArray(this.PopularProviders)
      }
    },
    watch: {
      activeServiceType () {
        if (this.isActive && this.PopularProviders == null) {
          this.getRecommendations()
        }
      }
    },
    methods: {
      activatePanel () {
        if (this.isActive) {
          this.$store.dispatch('recommendations/setActiveServiceType', null)
        } else {
          this.$store.dispatch('recommendations/setActiveServiceType', this.serviceType)
        }
      },
      getRecommendations () {
        return axios
          .get('/list/providers', {
            params: {
              service_type_id: this.serviceType.id
            }
          })
          .then((response) => {
            this.PopularProviders = response.data
          })
          // TODO webpack (mikew): Add fail state for request
      }
    },
    props: ['serviceType'],
    components: {
      Placeholder,
      ServiceTypeRecommendations
    }
  }
</script>

<style lang="stylus">
  .panel-st
    &__header
      color: white
      text-decoration: none
    &__label
      white-space: nowrap
      overflow: hidden
      text-overflow: ellipsis
    &__card
      min-height: 20rem
</style>



// WEBPACK FOOTER //
// frontend/src/components/recommendations/ServiceType.vue